export default "/_next/static/2cc6fe3d93e415572193a76aab390ff7.png";